<template>
<div :data="dataLesson" class="lesson-table">
  <el-table
    :data="dataLesson.data" header-row-class-name="month_header" header-cell-class-name="month_header"
    style="width: 100%;">
    <el-table-column
      prop="start_date"
      label="DATE"
      >
    </el-table-column>
    <el-table-column
      prop="start_time"
      label="TIME">
    </el-table-column>
    <el-table-column
      prop="subtitile"
      label="SUBJECT" width="190">
    </el-table-column>
    <el-table-column
      prop="levelstitle"
      label="LEVEL"
      >
    </el-table-column>
    <el-table-column
      prop="start_lessons"
      label="STUDENT">
      <template slot-scope="scope">
          <span v-text="scope.row.student_nickname"></span>
        </template>
    </el-table-column>
    <el-table-column
      prop="comment_status"
      label="NOTE"
      width="140">
      <template slot-scope="scope">
          <span>
            <button @click="dialogVisible(scope.row,0)" class="btnLeave" v-if="scope.row.comment_status==0">Leave a Note</button>
            <button @click="dialogVisible(scope.row,1)" class="btnView" v-if="scope.row.comment_status==1">View Note</button>
          </span>
        </template>
    </el-table-column>

    <el-table-column
      prop="feedback"
      label="FEEDBACK"
      align="center"
    >
      <template slot-scope="scope">
        <div class="feedback">
          <!-- <el-button type="text" @click="handleShowFeedback(scope.row)" :disabled="!scope.row.comment_show">View</el-button> -->
          <span :style="{fontSize: '14px', fontWeight: 'normal', color: !scope.row.comment_show ? '#BEBEBE' : '#FF6E17', cursor: !scope.row.comment_show ? 'not-allowed' : 'pointer' }" type="text" @click="() => scope.row.comment_show && handleShowFeedback(scope.row)" >View</span>
        </div>
      </template>
    </el-table-column>
  </el-table>
  <el-pagination
    @current-change="handleCurrentChange"
    :current-page="pagenum"
    :page-size="pagesize"
    layout="prev, pager, next"
    :total="dataLesson.total">
  </el-pagination>
  <el-dialog
    title="Note for the lesson"
    :visible.sync="centerDialogVisible"
    width="800px"
    custom-class="notedialogclass"
    center>
      <div class="el-dialog__message">
        <p>Your note will help us evaluate the students learning progress and provide them the best learning experience.</p>
        <p>Note:</p>
      </div>
      <div class="el-textarea">
        <textarea autocomplete="off" placeholder="Type your note here" class="el-textarea__inner" style="min-height: 36px;"  v-model="value"></textarea>
      </div>
      <div class="studentList flex_start">
        <div class="regularList">
          <p class="color_grey">Student：</p>
          <div class="stuArr">
            <p style="margin-left: 8px" title="Esther Howard" v-for="(studentItem, i) in student" :key="i">{{studentItem.nickname}}</p>
          </div>
        </div>
<!--        <div class="dropinList">-->
<!--          <p class="color_grey">Drop-in Student(s)</p>-->
<!--          <div class="stuArr"><p title="Esther Howard" v-for="(dropItem, i) in drop_student" :key="i">{{dropItem.nickname}}</p></div>-->
<!--        </div>-->
      </div>
      <el-button slot="footer" type="primary" @click="submit">Submit Comment</el-button>
  </el-dialog>
  <FeedbackTable v-model="showFeedBack" :lessonSn="lessonSn"></FeedbackTable>
</div>
</template>
<script>
import FeedbackTable from '../FeedbackTable.vue'
export default {
  props: {
    dataLesson: Object,
    required: true
  },
  components: {
    FeedbackTable
  },
  data () {
    return {
      pagenum: 1, // 当前页码
      pagesize: 10, // 每页显示条数
      centerDialogVisible: false,
      value: '',
      student: [],
      drop_student: [],
      info: {},
      showFeedBack: false,
      lessonSn: ''
    }
  },
  created () {
  },
  methods: {
    handleCurrentChange (val) { // 条目改变时
      this.pagenum = val
      this.$emit('page-num', this.pagenum)
    },
    dialogVisible (data, type) {
      this.info = data
      if (type == 1) {
        this.value = data.comnents
      } else {
        this.value = ''
      }
      this.centerDialogVisible = true
      this.$http.get('/tutor/api/getLessonStudents?lesson_sn=' + data.lesson_sn).then((res) => {
        if (res.data.code == 200) {
          this.student = res.data.data.student
          this.drop_student = res.data.data.drop_student
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch((error) => {
        console.log(error) // 请求失败返回的数据
      })
    },
    submit () {
      this.$http.post('/tutor/api/addTeacherComment', {
        comment: this.value,
        teacher_sn: this.info.teacher_sn,
        lesson_sn: this.info.lesson_sn,
        class_sn: this.info.class_sn
      }).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            message: res.data.data,
            type: 'success'
          })
          this.alertMsg()

          this.$emit('page-num', this.pagenum)
          this.centerDialogVisible = false
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch((error) => {
        console.log(error) // 请求失败返回的数据
      })
    },
    alertMsg () {
      this.$alert('<p style="font-size:30px;text-align: center;margin: 55px 0;">Thank you! Note Received.</p>', '', {
        confirmButtonText: 'Back to Main Page',
        dangerouslyUseHTMLString: true,
        callback: action => {
          this.search()
        }
      })
    },
    handleShowFeedback (record) {
      this.showFeedBack = true
      this.lessonSn = record.lesson_sn
    }
  }
}
</script>
<style lang="less" scoped>
  .lesson-table{
    margin-top: 20px;
    padding: 30px;
    background-color: #fff;
  }
  .btnLeave{
    color:#ff6440;
    width: 118px;
    height: 34px;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    padding: 6px 16px;
    gap: 0px 10px;
    flex-wrap: wrap;
    align-content: flex-start;

    background: rgba(255, 144, 77, 0.2);

    box-sizing: border-box;
    font-family: Arial;
    font-size: 14px;
    font-weight: normal;
    line-height: 20px;
    border: 1px solid #FF6B4A;
  }
  .btnView{
    background: rgba(41, 206, 115, 0.2);
    color: #29CE73;
    width: 118px;
    height: 34px;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    padding: 6px 16px;
    gap: 0px 10px;
    flex-wrap: wrap;
    align-content: flex-start;
    font-family: Arial;
    font-size: 14px;
    font-weight: normal;
    line-height: 20px;
    box-sizing: border-box;
    border: 1px solid #29CE73;
  }

  .studentList{
    //background: #ffffff;
    border-radius: 8px;
    margin:10px 0 0px 0;
    padding:7px 0;
    >div{
      flex:1;
      padding:7px 16px;
      >.color_grey{
        margin-bottom:10px;
        font-family: Arial;
        font-size: 14px;
        font-weight: normal;
        line-height: 28px;
        letter-spacing: 0px;

        color: #FF904D;
      }
      >.stuArr{
        line-height: 24px;
        p{
          width:100%;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          word-break: break-all;
          font-family: Arial;
          font-size: 14px;
          font-weight: 700;
          line-height: 28px;
          letter-spacing: 0px;

          color: #FF904D;
        }
      }
    }
    .regularList{
      border-right:1px solid #F8F8F8;
      display: flex;
      flex-direction: row;
    }
  }
  /deep/.notedialogclass{
    background-color: #FFFAE5 !important;
    .el-dialog__title{
      font-family: Arial;
      font-size: 36px;
      font-weight: bold;
      line-height: 28px;
      letter-spacing: 0px;

      font-variation-settings: "opsz" auto;
      color: #333333;
    }
    .el-dialog__header{
      padding: 46px 36px 0;
    }
    .el-dialog__body{
      padding: 36px 36px 0 36px !important;
    }
    .el-dialog__message{
      font-family: Arial;
      font-size: 14px;
      font-weight: normal;
      line-height: 28px;
      letter-spacing: 0px;

      color: #666666;
    }
    .el-dialog__message p+p{
       margin-top:2px;
    }
    .el-textarea__inner::placeholder{
      font-family: Arial;
      font-size: 14px;
      font-weight: normal;
      line-height: 28px;
      letter-spacing: 0px;

      color: rgba(0, 0, 0, 0.3);
    }
    .el-button{
      background: #FF904D;
      width: 100%;
      box-shadow: none;
      border: none;
      border-radius: 8px;
      span{
        font-family: Arial;
        font-size: 16px;
        font-weight: bold;
        text-align: center;
        letter-spacing: 0px;
        height: 48px;
        font-variation-settings: "opsz" auto;
        color: #FFFFFF;
      }
    }
    .el-dialog__footer{
      padding: 0 36px 38px 36px;
    }
  }
  /deep/.month_header{
    background: #F9FAFB !important;
    height: 40px !important;
  }
  .Absence{
    background: rgba(255, 144, 77, 0.2);
    color: #FF6B4A;
    border: 1px solid #FF6B4A;
  }
  .Present{
    background: rgba(41, 206, 115, 0.2);
    color: #29CE73;
    border: 1px solid #29CE73;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/lesson.vue